import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { t } from '~/helpers';

export default function View({ data }) {
  return (
    <Grid container spacing={2} style={{ padding: 16 }}>
      <Grid item xs={12}>
        <Typography>
          {t('s.geral.opcoes.datahorainicial')}:{' '}
          {data.datahorainicialalteracaocentrocusto}
        </Typography>
        <Typography>
          {t('s.geral.opcoes.datahorafinal')}:{' '}
          {data.datahorafinalalteracaocentrocusto}
        </Typography>
        <Typography>
          {t('s.menu.cadastro.veiculo')}: {data.idveiculo}
        </Typography>
        <Typography>
          {t('s.menu.cadastro.veiculo.centrocusto')}: {data.idcentrocusto}
        </Typography>
        <Typography>
          {t('s.geral.registros.alterados')}: {(data.itens || []).length}
        </Typography>
      </Grid>
    </Grid>
  );
}
View.propTypes = { data: PropTypes.shape({}) };
View.defaultProps = { data: {} };
